import React from 'react';
const { useNavigate } = require("react-router-dom");
const { useLazyGetFileUrlQuery } = require("store/services/utility");
import styles from './tableLayoutV2.module.scss'
import downArrow from 'Assets/images/downArrowPurple.png'
import upArrow from 'Assets/images/upArrowPurple.png'
import downArrowNormal from 'Assets/images/downArro.png'



const TableLayoutV2 = ({ openRow, toggleRow, handleGetRowColor, expandableRowComponent, column, data, url, showHeader = true, noDataMsg = "Data not found", state, filter, handleRowClick, height, handleSort }) => {
    const navigate = useNavigate();
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

    // const { data: consentFormList, error, isLoading: consentFormListLoading } = useGetConsentformListQuery({ client_id: clientId });

    const handleSortClick = (item) => {

        let sort = {};
        console.log('filter sort and item?.accessor', filter, item?.accessor)
        if (filter?.sort?.column == item?.accessor) {

            if (filter?.sort?.direction == "asc") sort = { column: item?.accessor, direction: "desc" };
            else sort = { column: "id", direction: "desc" };

        } else sort = { column: item?.accessor, direction: "asc" }

        typeof handleSort === "function" && handleSort(sort);
    };

    const handleViewPdf = async (name) => {

        try {
            const result = await getFileUrl(name);
            if (result?.error) return;

            const url = result?.data
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };



    return (
        <div className="favorite-goal-wrapper classroom-consultation proxima table_height" style={{ height: height || "calc(100vh - 220px)" }}>
            {
                getFileFetching && <LoadingOverlay />
            }
            <div className={`${styles.tableResponsive} table-responsive mb-3 h-100`}>
                <table className={`${styles.table} table`}>
                    {showHeader && (
                        <thead>
                            <tr className="">
                                {column &&
                                    column.length > 0 &&
                                    column.map((item, key) => (
                                        <>
                                            <th className="text-dark border-0" style={{ fontWeight: 500, background:"transparent" }}>
                                                <div className={`d-flex ${filter?.sort?.column == item?.accessor && "themePurple"}`}>
                                                    {item.head}
                                                    {
                                                        item?.sorter && <div className="px-2 cursor-pointer d-flex flex-column justify-content-center" onClick={() => handleSortClick(item)}>
                                                            {filter?.sort?.column == item?.accessor && filter?.sort?.direction?.toLowerCase() == "asc" && <img width={9} height={9} className="ms-2" src={upArrow} alt="downArrow" />}
                                                            {filter?.sort?.column == item?.accessor && filter?.sort?.direction?.toLowerCase() == "desc" && <img width={9} height={9} className="ms-2" src={downArrow} alt="downArrow" />}
                                                            {filter?.sort?.column != item?.accessor && <img width={9} height={6} className="ms-2" src={downArrowNormal} alt="downArrow" />}
                                                        </div>
                                                    }
                                                </div>
                                            </th >
                                        </>
                                    ))}
                            </tr>
                        </thead>
                    )}
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((row, idx) => (
                                <React.Fragment key={row.id || idx}>
                                    {/* Main Row */}
                                    <tr
                                        className={`${url || handleRowClick ? "cursor-pointer" : ""}`}
                                        onClick={(e) => {
                                            if (row?.pdfList?.[0]?.attachment_key)
                                                handleViewPdf(row?.pdfList?.[0]?.attachment_key);
                                            else {
                                                url && navigate(`${url}/${row.id}`, { state });
                                                handleRowClick?.(row);
                                            }
                                        }}
                                    >
                                        {column?.map((item, key) => (
                                            <td
                                                key={key}
                                                className={`${row?.status === "copied"
                                                    ? "copied-report-bcg"
                                                    : row?.status === "complete" && "published-report-bcg"
                                                    } ${openRow == row?.id && 'border-bottom-0 rounded-bottom-0'}
                                                    ${typeof (handleGetRowColor) == "function" ? handleGetRowColor(row) : ""}
                                                     `}
                                            >
                                                {item.component
                                                    ? item.component(row, idx, row)
                                                    : row[item?.accessor] || "--"}
                                            </td>
                                        ))}
                                    </tr>

                                    {/* Expanded Row */}
                                    {expandableRowComponent && openRow === row.id && (
                                        <tr style={{ position: 'relative', top: "-10px" }}>
                                            <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={2}></td>
                                            <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={7}>
                                                {expandableRowComponent(row)}
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={column?.length || 1} className="text-center">
                                    {noDataMsg}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div >
    );
};

export default TableLayoutV2


const ArrowUpFilled = () => {

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            fill="currentColor"
            class="bi bi-caret-up-fill"
            viewBox="0 0 16 16"
        >
            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
        </svg>
    )
};

const ArrowDownFilled = () => {

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            fill="currentColor"
            class="bi bi-caret-down-fill"
            viewBox="0 0 16 16"
        >
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
        </svg>
    )
}

const ArrowDownOutline = () => {

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            fill="currentColor"
            class="bi bi-caret-down"
            viewBox="0 0 16 16"
        >
            <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659" />
        </svg>
    )
}

const ArrowUpOutline = () => {

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            fill="currentColor"
            class="bi bi-caret-up"
            viewBox="0 0 16 16"
        >
            <path d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659" />
        </svg>
    )
}